interface Cookie {
  key: string;
  value: any;
}

export default function getCookies(): Cookie[] {
  const cookies: Cookie[] = JSON.parse(localStorage.getItem('cookies') || '[]');
  return cookies;
}

export function getCookie(key: string): any | undefined {
  const cookies = getCookies();
  const cookie = cookies.find((cookie) => cookie.key === key);
  return cookie?.value;
}

export function updateCookie(key: string, value: any): void {
  const cookies = getCookies();
  const otherCookies = cookies.filter((cookie) => cookie.key !== key);
  const newCookies = [...otherCookies, { key, value }];
  localStorage.setItem('cookies', JSON.stringify(newCookies));
}
